import { compose, filter, lte } from 'lodash/fp'
import { IRoom } from '../../../models/Room'

const getRoomSize = (room: FilteredRoom) =>
  Number(room.roomSize) + Number(room.additionalBeds)

export default function filterByName<T extends FilteredRoom>(
  appliedFilter: IFilter,
) {
  return filter<T>(
    compose(
      lte(appliedFilter.persons || 0),
      getRoomSize,
    ),
  )
}

interface IFilter {
  persons?: number
}

type FilteredRoom = Pick<Partial<IRoom>, 'roomSize' | 'additionalBeds'>
